import { render, staticRenderFns } from "./oplList.vue?vue&type=template&id=247d88c4&scoped=true&"
import script from "./oplList.vue?vue&type=script&lang=js&"
export * from "./oplList.vue?vue&type=script&lang=js&"
import style0 from "./oplList.vue?vue&type=style&index=0&id=247d88c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247d88c4",
  null
  
)

export default component.exports